import PencilIcon from "./pencil-icon";

// A check request only exists once the property has approved (Loyalty Cloud is complete), so the member is
// never on step 1. A pending request is the property payment step; the check is mailed after that.
// (`property_payment` is accepted too in case the deals response starts sending it.)
export const CHECK_STEP_BY_STATUS = { property_approved: 1, property_payment: 1, check_mailed: 2, delivered: 3 };
export const CHECK_STEP_WAITING = CHECK_STEP_BY_STATUS.property_payment;
export const CHECK_STEP_MAILED = CHECK_STEP_BY_STATUS.check_mailed;
const CHECK_STEP_NAMES = ["Property Approved", "Property Payment", "Check Mailed", "Delivered"];
// Estimate under each step until it is done. Finished steps read "Done".
const CHECK_STEP_ESTIMATES = [null, "2–4 months", "1–2 weeks", null];
// The status line and delivery estimate come from the step, so they always match the tracker above them.
const CHECK_STEP_STATUS_TEXT = ["Property approved", "Waiting for property referral payment", "Check mailed", "Delivered"];
const CHECK_STEP_DELIVERY = ["2–4 months", "2–4 months", "1–2 weeks", "Delivered"];
// The dots sit at the start, the centre of the 2nd and 3rd column, and the end, so the fill stops at each dot.
const CHECK_STEP_FILL = ["0%", "calc(37.5% - 5px)", "calc(62.5% - 5px)", "calc(100% - 10px)"];

export default function CheckTracker({ address, step, onEdit }) {
  const sublabels = CHECK_STEP_NAMES.map((name, index) => {
    if (index < step) return "Done";
    if (index === CHECK_STEP_NAMES.length - 1) return index === step ? "Current" : null;
    return CHECK_STEP_ESTIMATES[index];
  });
  const names = CHECK_STEP_NAMES;
  const fill = CHECK_STEP_FILL[step] ?? "0%";
  const statusText = CHECK_STEP_STATUS_TEXT[step];
  const deliveryText = CHECK_STEP_DELIVERY[step];
  return (
    <section className="ir-tracker">
      <h1>Your check is on the way</h1>
      <div className="ir-progress-track">
        <div className="ir-track" style={{ "--ir-fill": fill }}>
          <div className="ir-track-dots" aria-hidden="true">
            {names.map((name, index) => (
              <i key={name} className={index <= step ? "is-on" : ""} />
            ))}
          </div>
        </div>
        <div className="ir-track-labels">
          {names.map((name, index) => (
            <div key={name}>
              <strong className={index <= step ? "is-on" : ""}>{name}</strong>
              {sublabels[index] ? <span>{sublabels[index]}</span> : null}
            </div>
          ))}
        </div>
      </div>
      <div className="ir-tracker-divider" />
      <div className="ir-tracker-status">
        <div>
          <span>CURRENT STATUS</span>
          <strong>{statusText}</strong>
        </div>
        <div>
          <span>ESTIMATED DELIVERY</span>
          <strong>{deliveryText}</strong>
        </div>
      </div>
      <div className="ir-address-card">
        <div className="ir-address-top">
          <span>Mailing address</span>
          {onEdit ? (
            <button type="button" aria-label="Edit mailing address" onClick={onEdit}>
              <PencilIcon size={16} />
            </button>
          ) : null}
        </div>
        <strong>{address.name || "Your name"}</strong>
        {address.lines.map((line) => (
          <span key={line}>{line}</span>
        ))}
      </div>
    </section>
  );
}
